<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.clients.users.title') }}</h1>
      <div class="tw-flex tw-gap-6">
        <DebouncedSearch
          :query="searchQuery"
          :search="search"
          :placeholder="$t('common.actions.search')"
        />
        <i-button
          type="primary"
          size="medium"
          @click="isAddUserDialogOpen = true"
        >
          <icon-plus class="tw-mr-2" />
          {{ $t('adm.agency.users.create_button') }}
        </i-button>
      </div>
    </div>

    <div v-loading="isLoading">
      <ClientsUsersFilters class="tw-mb-8" />

      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/clients/users"
          list-relative-path="users"
          list-item-component-name="ClientsUsersListItem"
          list-item-prop-name="user"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/clients/users"
        filter-relative-path="filters"
      />
    </div>

    <AddClientsUserDialog
      :is-open="isAddUserDialogOpen"
      @close="isAddUserDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import { usersTableColumns } from '@/components/Administration/Client/Users/constants';
import AddClientsUserDialog from '@/components/Administration/Client/Users/AddClientsUserDialog.vue';
import ClientsUsersFilters from '@/components/Administration/Client/Users/ClientsUsersFilters.vue';
import DebouncedSearch from '@/components/shared/DebouncedSearch.vue';
import { mapState } from 'vuex';

export default {
  name: 'ClientsUsersV2',
  components: {
    DebouncedSearch,
    AddClientsUserDialog,
    ClientsUsersFilters,
    AdministrationTablePagination,
    AdministrationTableList,
    ForeignersMessagingPopover,
  },
  data() {
    return {
      isAddUserDialogOpen: false,
      searchQuery: '',
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.clients.users.filters,
      users: (state) => state.v2.admin.cms.clients.users.users,
      isLoading: (state) => state.v2.admin.cms.clients.users.isLoading,
    }),
    columns() {
      return usersTableColumns;
    },
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
    this.$store.dispatch('v2/admin/cms/clients/companies/loadAllCompanies');
    this.$store.dispatch('v2/shared/enums/loadClientUserRoles');
    this.searchQuery = this.filters.search;
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/clients/users/load');
    },
    search(query) {
      this.$store.commit('v2/admin/cms/clients/users/updateFilter', { field: 'search', payload: query });
    },
  },
};
</script>
